import React from 'react';
import { useLanguage } from './LanguageContext';
import ReactCountryFlag from 'react-country-flag';

const translations = {
  en: {
    nav: {
      home: 'Home',
      features: 'Features',
      howItWorks: 'How It Works',
      getStarted: 'Get Started'
    }
  },
  ar: {
    nav: {
      home: 'الرئيسية',
      features: 'المميزات',
      howItWorks: 'كيف يعمل',
      getStarted: 'ابدأ الآن'
    }
  }
};

const Header = () => {
  const { language, toggleLanguage } = useLanguage();
  const t = translations[language];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="flex items-center justify-between py-5">
          {/* Logo Section */}
          <div className="flex items-center">
            <div className="text-3xl font-bold text-primary flex items-center whitespace-nowrap" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <span className="mr-3 text-3xl">🍳</span>
              <span>24AI Cooking</span>
            </div>
          </div>

          {/* Navigation Links */}
          <nav className="hidden lg:flex items-center space-x-10 space-x-reverse mx-8">
            <a href="#" className="text-gray-700 hover:text-primary transition-colors duration-200 font-medium text-lg py-2">{t.nav.home}</a>
            <a href="#features" className="text-gray-700 hover:text-primary transition-colors duration-200 font-medium text-lg py-2">{t.nav.features}</a>
            <a href="#how-it-works" className="text-gray-700 hover:text-primary transition-colors duration-200 font-medium text-lg py-2">{t.nav.howItWorks}</a>
          </nav>

          {/* Right Side Actions */}
          <div className="flex items-center space-x-6 space-x-reverse">
            <button 
              onClick={toggleLanguage}
              className="flex items-center justify-center space-x-3 space-x-reverse px-6 py-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg transition-all duration-200 group"
            >
              <ReactCountryFlag
                countryCode={language === 'en' ? 'GB' : 'BH'}
                svg
                style={{
                  width: '22px',
                  height: '22px',
                }}
                title={language === 'en' ? 'English' : 'العربية'}
              />
              <span className="text-sm font-semibold text-gray-700">{language === 'en' ? 'English' : 'العربية'}</span>
            </button>
            <a 
              href="/start"
              className="px-10 py-3 bg-gradient-green text-white rounded-lg hover:opacity-90 transition-all duration-200 font-bold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 whitespace-nowrap"
              style={{ fontFamily: 'Poppins, sans-serif' }}
            >
              {t.nav.getStarted}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

